import { useQueryClient } from '@tanstack/react-query';
import {
  getGetETSTicketInformationQueryKey,
  getGetETSTicketNotificationsQueryKey,
  getGetETSTicketQueryKey,
  TicketsClientQueryKeys,
} from 'gcs-common/clients/api/entities/tickets/tickets-api-helpers';
import { PusherChannelEvent } from 'gcs-common/pusher/pusher-constants';
import { usePusherEvents } from 'gcs-common/pusher/pusher-hooks';

export function usePusherETSTicketsSubscription(currentUserId: string) {
  const queryClient = useQueryClient();
  usePusherEvents([
    {
      channelName: `presence-current-user-${currentUserId}`,
      eventName: PusherChannelEvent.ETS_TICKETS_UPDATED,
      callback: (ticketId: string) => {
        queryClient.invalidateQueries({
          queryKey: [TicketsClientQueryKeys.GET_ETS_TICKETS],
        });
        queryClient.invalidateQueries({
          queryKey: [TicketsClientQueryKeys.GET_ETS_TICKETS_INFINITE],
        });
        queryClient.invalidateQueries({
          queryKey: getGetETSTicketInformationQueryKey({ ticket_id: ticketId }),
        });
        queryClient.invalidateQueries({
          queryKey: getGetETSTicketQueryKey({ ticket_id: ticketId }),
        });
        queryClient.invalidateQueries({
          queryKey: getGetETSTicketNotificationsQueryKey(),
        });
      },
    },
  ]);
}
